import { isEmpty } from "lodash-es";
import {
  DisplayWrapper,
  EmptyMachineGroupWrapper,
  getTimeDifference,
  machineStatusDisplayLookup,
  NA,
  backgroundColorLookup,
} from "../helper/reportingHelper";
import { MachineStatusGrid } from "../status/grid/MachineStatusGrid";
import { MachineStatusGridItem } from "../status/grid/MachineStatusGridItem";
import { useTranslation } from "react-i18next";
import { ReportingMelcoMachineStatisticsModelsView } from "melco-shared-logic";

type DisplayMachineStatusViewGroupedProps = {
  viewDetail: ReportingMelcoMachineStatisticsModelsView;
  activeTooltip: string | null;
  onToggleTooltip: (machineName: string) => void;
};

export const DisplayMachineStatusViewGrouped: React.FC<
  DisplayMachineStatusViewGroupedProps
> = ({ viewDetail, activeTooltip, onToggleTooltip }) => {
  const { t } = useTranslation();

  return (
    <>
      {viewDetail?.group_list && viewDetail?.group_list?.length > 0 && (
        <>
          {viewDetail?.group_list?.map((group: any) => {
            return (
              <>
                <DisplayWrapper>
                  {group?.machine_list?.length > 0 ? (
                    <MachineStatusGrid title={group.name}>
                      <>
                        {group?.machine_list?.map((machine: any) => {
                          let machineStateValues = machine?.last_status
                            .split(",")
                            .map((value: any) => value.trim()) // Trim spaces
                            .join("-"); // Join with hyphen
                          // Create a lookup key by combining `a` and the trimmed and joined `b`
                          let lookupKey = "";
                          lookupKey = machine?.event_type ?? "";

                          if (String(lookupKey) === "MACHINE_STOP") {
                            if (String(machine?.stop_type) === "ESTOP")
                              machineStateValues = machine?.stop_type;
                          }

                          if (!isEmpty(machineStateValues))
                            lookupKey = lookupKey + "-" + machineStateValues;
                          // Find the matching result for the lookup key
                          const result = machineStatusDisplayLookup[lookupKey];
                          const backgroundColor =
                            backgroundColorLookup[
                            result?.bgColorId ? result.bgColorId : ""
                            ];
                          // console.log(
                          //   "310 ",

                          //   lookupKey,
                          //   " ",
                          //   result,
                          //   " ",
                          //   machine?.device_id,
                          //   "   ",
                          //   machine?.name,
                          //   " "
                          // );

                          console.log(
                            machine?.device_id ? machine?.device_id : "",
                            "   ",
                            machine?.name ? machine?.name : "",
                            " ",
                            machine?.event_type ? machine?.event_type : "",
                            " ",
                            result?.textId
                              ? t(`view.status.${result?.textId}` as string, {
                                defaultValue: "Unknown",
                              })
                              : "NA",
                            "       ",
                            result?.bgColorId
                              ? result?.bgColorId + "-color ---> "
                              : "      ",

                            backgroundColor,
                            " "
                          );
                          return (
                            <>
                              {/* <MachineStatusGridItem
                                key={viewDetail.id + "" + machine.device_id}
                                keyForTooltip={
                                  viewDetail.id + "" + machine.device_id
                                }
                                machineName={machine.name}
                                status={result ?? NA}
                                tooltip={
                                  machine?.inactive
                                    ? getTimeDifference(
                                        machine?.last_sync_date
                                      ) + " ago"
                                    : undefined
                                }
                                isActive={
                                  activeTooltip ===
                                  viewDetail.id + "" + machine.device_id
                                }
                                onToggle={onToggleTooltip}
                              /> */}

                              <MachineStatusGridItem
                                key={
                                  viewDetail.id +
                                  "" +
                                  group.name +
                                  "" +
                                  machine.device_id
                                }
                                keyForTooltip={
                                  viewDetail.id +
                                  "" +
                                  group.name +
                                  "" +
                                  machine.device_id
                                }
                                machineName={machine.name}
                                status={result ?? NA}
                                isActive={
                                  activeTooltip ===
                                  viewDetail.id +
                                  "" +
                                  group.name +
                                  "" +
                                  machine.device_id
                                }
                                onToggle={onToggleTooltip}
                                tooltip={
                                  machine?.inactive
                                    ? getTimeDifference(
                                      machine?.last_sync_date
                                    ) +
                                    " " +
                                    t("view.status.ago")
                                    : undefined
                                }
                              />
                            </>
                          );
                        })}
                      </>
                    </MachineStatusGrid>
                  ) : (
                    <></>
                  )}
                </DisplayWrapper>
              </>
            );
          })}
        </>
      )}

      {viewDetail?.group_list && viewDetail?.group_list?.length == 0 && (
        <EmptyMachineGroupWrapper>
          {t("view.no_group_in_view")}
        </EmptyMachineGroupWrapper>
      )}
    </>
  );
};
